const weChat_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?';

const redirect_url = encodeURIComponent(
    process.env.http_env
        ? `${window.location.origin}/${process.env.http_env}/productList`
        : `https://dev.xianhuo.thermofisher.com/productList`,
);
// const prefix = process.env.http_env ? `/${ process.env.http_env }/api` : '/api';
const prefix = '/api';

// QA
// const prefix = 'https://qa.xianhuo.thermofisher.cn/api';
// uat
// const prefix = 'https://uat.xianhuo.thermofisher.cn/api';
// HuiZhe
// const prefix = 'http://10.68.161.32:10086/api';
// TieJun
// const prefix = 'http://10.68.161.23:10000/api';
// GaoQin
// const prefix = 'http://10.69.22.90:8080/dev/api';
// YunPent
// const prefix = 'http://10.69.20.71:10000/api';
//Zhangkai
// const prefix = 'http://10.68.161.147:10001/api';
// Jason
// const prefix = 'http://10.68.161.139:10000/api';
// yinzhen
// const prefix = 'http://10.68.161.144:10000/api';

export const getCodeUrl =
    weChat_url +
    '&redirect_uri=' +
    redirect_url +
    '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
export const gigyaUnbindUrl =
    process.env.http_env !== 'prod'
        ? process.env.http_env === 'uat'
            ? 'https://qa1.thermofisher.cn/api-gateway/identity-wechat/identity/wechat/auth/unbind'
            : 'https://qa4.thermofisher.cn/api-gateway/identity-wechat/identity/wechat/auth/unbind'
        : 'https://www.thermofisher.cn/api-gateway/identity-wechat/identity/wechat/auth/unbind';

// external url
export const useClausesUrl =
    'https://www.thermofisher.cn/cn/zh/home/global/terms-of-use.html';
export const termsConditionUrl =
    'https://www.thermofisher.cn/cn/zh/home/global/terms-and-conditions.html';
export const privacyUrl =
    'https://www.thermofisher.cn/cn/zh/home/global/privacy-policy.html';
export const pricingConsignmentUrl =
    'https://www.thermofisher.cn/cn/zh/home/global/online-pricing-policy.html';

export const customerConfirmLink =
    process.env.http_env === 'prod'
        ? 'https://mapac.thermofisher.cn/my-orders/PendingLTO/'
        : 'https://qa1-mapac.thermofisher.cn/my-orders/PendingLTO/';
export const quotePrefix =
    process.env.http_env === 'prod'
        ? 'https://api-mapac.thermofisher.cn'
        : process.env.http_env === 'qa'
        ? 'https://qa1-api-mapac.thermofisher.cn'
        : 'https://qa1-api-mapac.thermofisher.cn';

export const mobilityPrefix =
    process.env.http_env === 'prod'
        ? 'https://mapac.thermofisher.cn'
        : process.env.http_env === 'qa'
        ? 'https://qa1-mapac.thermofisher.cn'
        : 'https://qa1-mapac.thermofisher.cn';
export const originDomain = `${window.location.origin}/`;

// login
export const adminUserUrl = prefix + '/admin/login';
export const userLoginUrl = prefix + '/customer/login';
export const bindEmailUrl = prefix + '/customer/bind';
export const unBindUrl = prefix + '/customer/unBind';
export const registerUrl = prefix + '/customer/register';
export const validMobileUrl = prefix + '/admin/verify/mobile';
export const validEmailUrl = prefix + '/customer/verify/email';
export const validCodeUrl = prefix + '/customer/verify/code';
export const validOpenIdUrl = prefix + '/customer/login/openId';
export const authCodeUrl = prefix + '/customer/send/authCode';
export const gigyaLoginUrl = prefix + '/customer/login/token';
export const testMockLoginUrl = prefix + '/customer/login/email';
export const existsCustomerTokenUrl = prefix + '/customer/info';

// export const defaultShipToAndSCUrl = prefix + '/sible/shipToAndSc';
export const getProxySupplyCenterUrl = prefix + '/proxy/sc/getSupplyCenter';
export const supplyCenterUrl = prefix + '/sc/getByShipToNum';

// Address
export const provinceUrl = prefix + '/area/province';
export const cityUrl = prefix + '/area/city';

// order
export const shipToUrl = prefix + '/customer/shipTo';
export const categoryListUrl = prefix + '/category/list';
export const productListUrl = prefix + '/proxy/product/list';
export const addCartUrl = prefix + '/proxy/cart/add';
export const queryCartUrl = prefix + '/proxy/cart/query';
export const queryEoneInventoryUrl = prefix + '/product/tfs/inventory';
export const cmgtInventoryUrl = prefix + '/proxy/web-product/inventory';
export const deleteCartUrl = prefix + '/proxy/cart/delete';
export const updateShipToUrl = prefix + '/customer/update/shipToNum';
export const promosPriceUrl = prefix + '/proxy/order/promos/apply';
export const cartCountUrl = prefix + '/proxy/cart/cartCount';
export const orderPreview = prefix + '/proxy/order/preview';
export const range_CRD_Url = prefix + '/product/crd-range';
export const orderAdd = prefix + '/order/add';
export const stContactQuery = prefix + '/stContact/query';
export const queryTMSKUUrl = prefix + '/proxy/web-product/list';
export const repeatOrderUrl = prefix + '/proxy/cart/repeat/add';
export const getOnlineCustomerAccountUrl =
    prefix + '/onlineAccount/getCustomerAccount';
export const cartQuantityUrl = prefix + '/proxy/cart/quantity';
export const queryQuoteUrl = prefix + '/quote/sku';
export const queryCustomerQuoteUrl =
    quotePrefix + '/marketing-api/activity-product/promotions?skus=';
export const dpDetailUrl = '/campaigns/m/';
export const marketingSsoAuthorizeUrl =
    mobilityPrefix + '/campaigns/sso/authorize';
export const promotionSsoUrl = prefix + '/sso/promotions/url';
export const searchHistoryUrl = prefix + '/search/historical';
export const hotTermUrl = prefix + '/search/hotTerm';
export const recommendProductsUrl = prefix + '/product/recommendProducts';
export const cartRecommendProductsUrl =
    prefix + '/product/cartRecommendProducts';
export const operationLogUrl = prefix + '/operationLog/insert';
export const sQouteUrl = prefix + '/proxy/order/promos/s/quote';
export const queryChangeShipUrl = prefix + '/proxy/cart/query/changeShip';
export const openTfsRuleUrl =
    originDomain + 'att/Thermo_Fisher_China_Booking_Policy_V1.pdf';
export const openTfsChangeRuleUrl =
    originDomain + 'att/Thermo_Fisher_China_Sales_Return_Policy_V2.pdf';
export const getUploadFileLimitUrl = prefix + '/sysConfig/getConfig';
export const saveAssayIdUrl = prefix + '/proxy/cart/assayId';

// User center
export const myOrderListUrl = prefix + '/proxy/order/query';
export const myOrderDetailUrl = prefix + '/proxy/order/view';
export const updateOrderProofsUrl = prefix + '/proxy/order/proofs/update';
export const hostDeliverToShipUrl = prefix + '/shipment/toShip';
export const receiveMyOrderUrl = prefix + '/shipment/receiveOrderShipments';
export const myOrderCountUrl = prefix + '/proxy/order/myOrderCount';
export const getShipmentsUrl = prefix + '/shipment/viewOrderShipment';
export const getMyBackupListUrl = prefix + '/stock-up/list';
export const applyBackupUrl = prefix + '/stock-up/add';
export const customerBackupUrl = prefix + '/stock-up/customer/add';
export const getSearchSCList = prefix + '/sc/list';
export const syncSTUrl = prefix + '/eonestbt/pullShipTo';
export const syncOnlineAccountUserUrl = prefix + '/onlineAccount/syncUser';
export const getInventoryBySkuAndSCUrl = prefix + '/stock-up/inventory'; //备货申请，根据sku和现货中心获取库存信息
export const getAlphaInfoUrl = prefix + '/eonestbt/alphaInfo'; //备货申请，获取课题组相关信息
export const stockupCancelUrl = prefix + '/stock-up/cancel';
export const getSystemNotificationUrl = prefix + '/notification/avaliable';
export const completeShippingPlanUrl = prefix + '/shipping/plan/complete';

export const notificationListUrl = prefix + '/notification/system/list';
export const notificationActionUrl =
    prefix + '/notification/system/saveNotification';
export const deleteNotificationUrl = prefix + '/notification/system/delete';
// export const getInventoryBySkuAndSCUrl = prefix + '/replenishment/get/inventory';

// host
export const hostOrderListUrl = prefix + '/shipment/viewHostOrder';
export const completedOrderListUrl = prefix + '/shipment/viewCompletedOrder';
export const shipmentListUrl = prefix + '/shipment/viewShipment';
export const hostShipmentListUrl = prefix + '/shipment/viewHostShipment';
export const hostShipmentDetailUrl =
    prefix + '/shipment/viewHostShipmentDetail';

export const getTaskAssignmentListUrl = prefix + '/task/assignment/listBySt';
export const getSpecialTagListUrl = prefix + '/stsc/special-tag/list';

export const shipmentShipUrl = prefix + '/shipment/ship';
export const shipmentHoldOrderUrl = prefix + '/shipment/hold';
export const shipmentWaitOrderUrl = prefix + '/shipment/ready';
export const cancelOrderUrl = prefix + '/shipment/cancel';
export const receiveShipmentUrl = prefix + '/shipment/receiveShipment';
export const getReceiveCodeUrl = prefix + '/shipment/receivingCode';

export const updateOtherImagesUrl = prefix + '/shipment/updateOtherImages';
export const deleteShipmentAttachmentUrl = prefix + '/shipment/deleteAtt';
export const updateShipmentUrl = prefix + '/shipment/updateShipment';
export const checkOrderStatusUrl = prefix + '/shipment/checkOrderStatus';
export const cancelPackageUrl = prefix + '/shipment/recallShip';
export const f1OrderListUrl = prefix + '/F1/order/query';
export const f1OrderDetailsUrl = prefix + '/F1/order/view';
export const f1OrderReceiveUrl = prefix + '/f1Shipment/receive';
export const createInvoicePdfUrl = prefix + '/shipment/printDispatchPdf';
export const printDispatchPdfsUrl = prefix + '/shipment/printDispatchPdfs';
export const abnormalRecordListUrl = prefix + '/abnormalRecord/management';
export const saveAbnormalRecordUrl = prefix + '/abnormalRecord/save';
export const getSCListUrl = prefix + '/sc/list/admin';
export const getSkuReplenishmentDetailsUrl = prefix + '/f1Shipment/history';
export const getAllSkuConditionUrl = prefix + '/product/querySKUCondition';
export const createRecommendPdfUrl = prefix + '/order/extend/recommendPdf'; //TODO
export const shipmentUpdateTrackNumberUrl =
    prefix + '/shipment/updateExpressNum';
export const f1ShipmentViewUrl = prefix + '/f1Shipment/view';
export const f1ShipmentWaitReceivelUrl = prefix + '/f1Shipment/waitReceive';
export const viewOnTheGoPackageUrl = prefix + '/F1/order/viewTravelingPackage';
export const f1ShipmentWaitShipUrl = prefix + '/f1Shipment/waitShip';
export const f1ShipmentReceivedUrl = prefix + '/f1Shipment/received';
export const f1ShipmentReceiveUrl = prefix + '/f1Shipment/receive';
export const f1ShipmentreceiveExUrl = prefix + '/f1Shipment/receiveEx';
export const userCenterAdventQuantityUrl =
    prefix + '/replenishment/get/advent-inventory-count-step1';
export const adventProductOfSCListUrl =
    prefix + '/replenishment/get/advent-inventory-count-step2';
export const addAdventInventorDetailUrl =
    prefix + '/replenishment/list/advent-inventory-detail';
export const tagUploadUrl = prefix + '/replenishment/inventory-expired-pic';
export const previewTagUploadUrl = prefix + '/download/pic';
export const deliverDetailUrl = prefix + '/shipment/detail';
export const shipmentPackageQuantityUrl = prefix + '/shipment/packageQuantity';
export const shipmentDocumentCoaUrl = prefix + '/shipment/documentCoa';
export const shipmentProxyPdfUrl = prefix + '/shipment/proxy/pdf';
export const shipmentNotificationSendUrl =
    prefix + '/shipment/notification/send';
export const shipmentNotificationCheckUrl =
    prefix + '/shipment/notification/check';
export const internalOrderQueryUrl = prefix + '/internal/order/query';
export const internalAddOrderNoUrl = prefix + '/internal/order/addExpress';
export const internalWithdrawUrl = prefix + '/internal/order/cancel';
export const internalUpdatedOrderNoUrl =
    prefix + '/internal/order/updateExpress';
export const internalReceivedGoodUrl = prefix + '/internal/order/receive';
export const internalRedQuantityUrl =
    prefix + '/internal/order/shipOrReceiveCount';
export const internalOrderQueryKitUrl = prefix + '/internal/order/kit';
export const internalOrderTransferApplyUrl =
    prefix + '/internal/order/transfer/apply';
export const getInternalOrderScHostAddressUrl =
    prefix + '/internal/order/getScHostAddress';
export const getSkuKitListOfInternalOrderUrl =
    prefix + '/internal/order/getSkuKitList';
export const getLotQuantityOfInternalOrderUrl =
    prefix + '/internal/order/getLotQuantity';
export const internalOrderDetailUrl = `${prefix}/internal/order/view`;
export const updateShipStatusUrl = `${prefix}/internal/order/receive`;
export const getOrderDetailMessageCountUrl = prefix + '/message/count';
export const getOrderDetailMessageListUrl = prefix + '/message/hostQuery';
export const getOrderDetailOneKeyReadUrl = prefix + '/message/oneKeyRead';
export const getYourMsgTotalUrl = prefix + '/message/unReadTotal';
export const getYourMsgListUrl = prefix + '/message/search';
export const signReadUrl = prefix + '/message/read';
export const f1OrderListRefreshUrl = prefix + '/f1Shipment/refresh';
export const getF1PackageOnTheGoListUrl =
    prefix + '/F1/order/getTravelingPackage';
export const viewOrderTrackingUrl = prefix + '/F1/order/viewOrderTracking';
export const getF1MessageListUrl = prefix + '/message/f1HostQuery';
// Proxy Delivery Order Management
export const getProxyDeliveryOrderListUrl =
    prefix + '/proxy/delivery/order/query';
export const getProxyDeliveryShipmentListUrl =
    prefix + '/proxy-delivery/shipment/list';
export const viewProxyDeliveryShipmentListUrl =
    prefix + '/proxy-delivery/shipment/viewShipment';
export const receiveProxyDeliveryPackageUrl =
    prefix + '/proxy-delivery/shipment/receiveShip';
export const viewProxyDeliveryOrderTrackingUrl =
    prefix + '/proxy/delivery/order/viewOrderTracking';
export const rejectProxyDeliveryPackageUrl =
    prefix + '/proxy-delivery/shipment/rejectShip';

export const gaoMapCurrentLocationUrl = 'http://restapi.amap.com/v3/ip';
export const punchSaveUrl = prefix + '/punch/save'; //打卡和打卡异常都调用此接口
export const punchReceivableUrl = prefix + '/punch/receivable'; //
export const feedbackSaveUrl = prefix + '/feedback/save'; //保存客户反馈
export const feedbackListUrl = prefix + '/feedback/list'; //客户反馈List
export const b2bCasmartShipmentUrl =
    prefix + '/b2b/shipment/generateDeliveryForm'; //b2b Casmart发货

//My order picking
export const queryPickOrderListUrl = prefix + '/pick-order/query';
export const cancelPickOrderUrl = prefix + '/pick-order/cancel';
export const savePickOrderUrl = prefix + '/pick-order/save';
export const shipOrderUrl = prefix + '/pick-order/shipOrder';
export const forceCancelUrl = prefix + '/pick-order/forceCancel';
export const batchRecommendPdfsUrl = prefix + '/order/extend/recommendPdfs'; //TODO
export const pickOrderPreviewPdfsUrl = prefix + '/pick-order/preview';
export const messageOneKeyReadUrl = prefix + '/message/oneKeyRead';
export const getPickOrderMessageUrl = prefix + '/pick-order/getOrderMessage';

//st management
export const getStManagementListUrl = prefix + '/stsc/mobile/search';
export const queryShipToBySupplyCenterListUrl = prefix + '/stsc/sc'; //Query change supply center list
export const getTransportMethodUrl =
    prefix + '/sc/getConfig/ST_TRANSPORT_METHOD'; //get transport method
export const saveStApplyChangeUrl = prefix + '/stsc/apply/save'; //Save st management apply change

//query invalid sku
export const invalidSkuListUrl = prefix + '/invalid/product/queryBySku';

// customer
export const customerListUrl = prefix + '/eonestbt/shipToList';
export const searchHostCustomerListUrl = prefix + '/sible/searchShipToByHost';
export const searchShipToByCustomerListUrl =
    prefix + '/sible/searchShipToByCustomer';
export const salesCustomerAccountListUrl = prefix + '/search/customerAccount'; //sales 代下单

// replenishment
export const replenishmentSCListUrl = prefix + '/replenishment/sc/list';
export const getAllSCListUrl = prefix + '/sc/list/map';
export const replenishmentStockListUrl = prefix + '/replenishment/stock/list';
export const fOneBatchAddUrl = prefix + '/F1/cart/batchAdd';
export const fOneAddUrl = prefix + '/F1/cart/add';
export const fOneCartCountUrl = prefix + '/F1/cart/cartCount';
export const fOneCartDeleteUrl = prefix + '/F1/cart/delete';
export const fOneCartQuantityUrl = prefix + '/F1/cart/quantity';
export const fOneCartQueryUrl = prefix + '/F1/cart/query';
export const submitF1OrderUrl = prefix + '/F1/order/add';
export const fOneOrderQueryUrl = prefix + '/F1/order/query';
export const viewFoneOrderUrl = prefix + '/F1/order/view';
export const f1CancelOrderUrl = prefix + '/f1Shipment/cancel';
export const f1UpdateOrderUrl = prefix + '/f1Shipment/adjustOrder';
export const inventoryDetailsUrl = prefix + '/product/lotInfo';
export const sysDictUrl = prefix + '/sys/dict';
export const includeProductUrl = prefix + '/product/list/components';
export const addSelectedLotCacheUrl = prefix + '/F1/cart/addSelectedLot2Cache';
export const getF1CartLatestDnsaUrl = prefix + '/F1/cart/getLatestDnsa';
export const replenishmentAddCartUrl = prefix + '/F1/cart/add-directly';
export const replenishmentValidSkuUrl =
    prefix + '/replenishment/validate/sc/sku';

// inventory query management
export const inventoryQueryListUrl = prefix + '/replenishment/inventory';

// upload file
export const uploadFileUrl = prefix + '/upload/file';

// personal page
export const personalInfoUrl = prefix + '/customer/viewPersonalInfo';
export const feedbackUrl = prefix + '/userAdvice/add';
export const scHostInforUrl = prefix + '/admin/list/service';
export const orderReportUrl = prefix + '/email/orderReport';

// Demo Site
export const demoProductUrl = prefix + '/demoProduct/listProducts';

// account lock or Unlock
export const lockUnlockUrl = prefix + '/accountCredit/lockUnlock';

//SKu Inventory detail
export const getSKUInventoryDetailUrl = prefix + '/order/querySKUStock'; //TODO

//scrap
export const scrapUploadUrl = prefix + '/abnormalRecord/upload-pic';
export const supplyCenterListUrl = prefix + '/sc/list/admin';
export const skuVagueSearch = prefix + '/replenishment/list/skuinfo';
export const getScrapTypeUrl = prefix + '/abnormalRecord/getScrapType';
export const checkF1NumberUrl = prefix + '/F1/order/getReceivedShipment';
export const e1GetSkuListUrl = prefix + '/F1/order/getReceivedShipmentSku';
export const getScrapParamsUrl = prefix + '/F1/order/getReceivedShipmentLot';

//Apply  listing
export const checkSkuUrl = prefix + '/replenishment/validate/sku';
export const addApplyProductUrl = prefix + '/replenishment/add/sku';

//all apply
export const allApplyQueryUrl = prefix + '/stsc/apply/search';
export const allApplyRevokeUrl = prefix + '/stsc/apply/view';
export const allApplyBackupUrl = prefix + '/stsc/apply/cancel';

//Demo site order
export const getShipToOfScInforUrl = prefix + '/stsc/getShipToScInfo';
export const getCmgtOfSkuInforUrl = prefix + '/CMGT/getSkuInfo';
export const batchAddShoppingCartUrl = prefix + '/proxy/cart/batchAdd';

//LTO
export const ltoPurchaseOrderHistoryUrl = prefix + '/lto/list';
export const ltoPurchaseOrderHistoryDetailsUrl = prefix + '/lto/detail';
export const proxyOrderAddUrl = prefix + '/proxy/order/add';
export const getNotificationChannelUrl = prefix + '/lto/getNotificationChannel';
export const reminderNotificationUrl = prefix + '/lto/reminder';
export const ltoCancelOrderUrl = prefix + '/lto/order/cancel';

//Shipping plan
export const saveShippingPlanUrl = prefix + '/shipping/plan/save';
export const getShippingPlanListUrl = prefix + '/shipping/plan/detail';
export const updateHostShippingPlanUrl = prefix + '/shipping/plan/process';

// SSO login
export const ssoLoginUrl = prefix + '/sso/user/login';
export const ssoGoUserCenterUrl = originDomain + 'purchase/sso/userCenter';

//Task management
export const getTaskListUrl = prefix + '/task/list';
export const getAssignmentListUrl = prefix + '/task/assignment/list';
export const getTaskCountUrl = prefix + '/task/forceTaskCount';
export const getTaskDetailsDataUrl = prefix + '/task/customer/detail';
export const submitTaskUrl = prefix + '/task/submit';
export const savedCustomerDetailUrl = prefix + '/task/customer/saved/detail';
export const addMessageUrl = prefix + '/message/add';
export const getTaskAnswerDetailDataUrl = prefix + '/task/answerDetail';
